import { CommonModule } from '@angular/common';
import { ComponentFactoryResolver, inject, Injector, ModuleWithProviders, NgModule } from '@angular/core';
import { surviveTreeShaking } from '@df/ng/survive-tree-shaking';
import { DfModalService } from '@df/ui/modal/df-modal.service';
import defaultsDeep from '@df/util/fn/defaults-deep';
import { DeepPartial } from '@df/util/type/deep-partial';
import { ICmsModalOpenDirective } from '../client/assets/modal/icms-modal-open.directive';
import { ICmsModalService } from '../client/assets/modal/icms-modal.service';
import { ICmsCoreModule } from './../core/icms-core.module';
import { ICmsClientAdminLoaderService } from './admin-loader/icms-client-admin-loader.service';
import { ICmsComponentComponent } from './assets/component/icms-component.component';
import { ICmsClientGlobalStylesComponent } from './assets/global-styles/icms-client-global-styles.component';
import { ICmsLinkDirective } from './assets/link/icms-link.directive';
import { ICmsOutletComponent } from './assets/outlet/icms-outlet.component';
import { ICmsDirective } from './assets/text/icms.directive';
import { ICMS_CLIENT_CONFIG, ICMS_CLIENT_CONFIG_DEFAULT, NICmsClientConfig } from './config/icms-client.config';

@NgModule({
    declarations: [
        ICmsDirective,
        ICmsLinkDirective,
        ICmsOutletComponent,
        ICmsComponentComponent,
        ICmsClientGlobalStylesComponent,
        ICmsModalOpenDirective
    ],
    exports: [ICmsDirective, ICmsOutletComponent, ICmsLinkDirective, ICmsModalOpenDirective, ICmsComponentComponent],
    imports: [ICmsCoreModule, CommonModule]
})
export class ICmsClientModule {
    static forRoot(config: DeepPartial<NICmsClientConfig.IConfig>): ModuleWithProviders<ICmsClientModule> {
        return {
            ngModule: ICmsClientModule,
            providers: [
                {
                    provide: DfModalService,
                    useExisting: ICmsModalService
                },
                {
                    provide: ICMS_CLIENT_CONFIG,
                    useFactory: () => {
                        return defaultsDeep(config || {}, ICMS_CLIENT_CONFIG_DEFAULT);
                    }
                }
            ]
        };
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    private injector = inject(Injector);
    private componentFactoryResolver = inject(ComponentFactoryResolver);

    constructor() {
        const icmsClientAdminLoaderService = inject(ICmsClientAdminLoaderService);
        const iCmsModalService = inject(ICmsModalService); // we need to instantiate it to make initiators work
        surviveTreeShaking([ICmsClientGlobalStylesComponent]);
        this.componentFactoryResolver.resolveComponentFactory(ICmsClientGlobalStylesComponent).create(this.injector);
    }
}
